import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_ACCRUALANZ_LOAD_BY_TRIAL_ID,

    IAccrualANZLoadByTrialIdAction,
    IAccrualANZLoadFailureAction,
    IAccrualANZLoadSuccessAction,

    LoadSuccess,
    LoadFailure,
    ACTION_ACCRUALANZ_LOAD_BY_ID,
    IAccrualANZLoadByIdAction,

} from "../actions/accrualANZ";
import { accrualANZApi } from "../services/accrualANZ";


export const
    getAccrualANZByIdEpic = (action$): Observable<IAccrualANZLoadSuccessAction | IAccrualANZLoadFailureAction> => {
        return action$
            .ofType(ACTION_ACCRUALANZ_LOAD_BY_ID)
            .mergeMap((action: IAccrualANZLoadByIdAction) => {
                return accrualANZApi
                    .getAccrualANZById(action.id)
                    .map(response =>
                        LoadSuccess(response.accrualANZ, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getAccrualANZByTrialIdEpic = (action$): Observable<IAccrualANZLoadSuccessAction | IAccrualANZLoadFailureAction> => {
        return action$
            .ofType(ACTION_ACCRUALANZ_LOAD_BY_TRIAL_ID)
            .mergeMap((action: IAccrualANZLoadByTrialIdAction) => {
                return accrualANZApi
                    .getAccrualANZByTrialId(action.trialId)
                    .map(response =>
                        LoadSuccess(response.accrualANZ, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    }